/**
 * FG Magnit — collection layout switch (grid / list).
 *
 * The grid is the default and works with no script. This only adds a toggle
 * that puts a class on the product grid and remembers the choice for the next
 * visit. Dawn replaces the grid's markup when a filter is applied, so the class
 * is re-applied whenever that happens.
 */
const FG_VIEW_KEY = 'fg-collection-view';

class FgCollectionView extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-view]'));
    if (!this.buttons.length) return;

    this.buttons.forEach((button) =>
      button.addEventListener('click', () => this.apply(button.dataset.view, true))
    );

    this.apply(this.stored() || 'grid', false);

    // Filtering swaps #ProductGridContainer's contents, which drops the class.
    const host = document.getElementById('ProductGridContainer');
    if (host && 'MutationObserver' in window) {
      this.watcher = new MutationObserver(() => this.paint());
      this.watcher.observe(host, { childList: true, subtree: true });
    }
  }

  disconnectedCallback() {
    this.watcher?.disconnect();
  }

  stored() {
    // Storage is per browser and can throw in private windows, so a failure
    // here just means the grid default is used.
    try {
      return localStorage.getItem(FG_VIEW_KEY);
    } catch (error) {
      return null;
    }
  }

  apply(view, remember) {
    this.view = view === 'list' ? 'list' : 'grid';

    this.buttons.forEach((button) => {
      const on = button.dataset.view === this.view;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.paint();

    if (!remember) return;
    try {
      localStorage.setItem(FG_VIEW_KEY, this.view);
    } catch (error) {
      /* nothing to do: the choice simply will not persist */
    }
  }

  paint() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.classList.toggle('fg-coll__grid--list', this.view === 'list');
  }
}

if (!customElements.get('fg-collection-view')) {
  customElements.define('fg-collection-view', FgCollectionView);
}
